import { Component } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

/**
 * Cookie consent component for Audi.
 * Google Analytics are only sent if the user agrees to the cookie consent.
 **/
@Component({
    selector: 'cookie-consent',
    templateUrl: './cookie-consent.component.html',
    styleUrls: ['./cookie-consent.component.scss'],
    providers: [CookieService]
})
export class CookieConsentComponent {
    constructor(private dialogRef: DynamicDialogRef, private cookieService: CookieService) { }

    onAcceptCookies(): void {
        this.cookieService.set('ecmp_allowAnalytics', 'true', 365);
        if (this.dialogRef) {
            this.dialogRef.close(true);
        }
    }

    onDeclineCookies(): void {
        this.cookieService.set('ecmp_allowAnalytics', '', 365);
        if (this.dialogRef) {
            this.dialogRef.close(false);
        }
    }
}
